/**
 * Basics Dice Factory
 *
 * For basics, all 4 colors use the same Dice component
 * (football field has no color variants).
 */

import Dice from './Dice';

export const RedDice = Dice;
export const BlueDice = Dice;
export const YellowDice = Dice;
export const GreenDice = Dice;
